import React, { useState } from 'react';
import { Table, TableBody, TableHead, Paper, Grid, TextField, Button, IconButton, TableRow, TableCell, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import moment from 'moment';
import { useSnackbar } from 'notistack';
import MomentUtils from '@date-io/moment';
import { backendDateFormat, displayDateFormatShort } from '../../../constants';
import { globalDeleteService } from '../../../globalServices';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { CkEditorText } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';
import { DeletePopUp } from '../../../shared_elements';
import { trackActivity } from '../../../utils/mixpanel';
import { smbcInstance } from '../../../shared_elements/components';
function EngineCondition({ data, setData, onFieldChange, callthisapi, getResponseBack, currentFormDetail, setInitialValue, setLoading, isLoading, setFormSave, formSave }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [deleteModal, setDeleteModal] = useState({ modal: false, data: null })

    const svNextDis = data?.engine_condition_stands ? data?.engine_condition_stands?.next_sv_date?.filter(item => item?.id)?.length === data?.engine_condition_stands?.next_sv_date?.length : []
    const fh_fc_ratio = Number(data?.engine_condition_stands?.avg_fh / data?.engine_condition_stands?.avg_fc)
    const interval_fhsCal = Number(data?.engine_condition_stands?.expected_fh_interval?.thrust_is - data?.engine_condition_stands?.tsl_hsv)

    const getFhFcRatioValue = (data, fhFcRatio) => {
        const storedValue = data?.engine_condition_stands?.fh_fc_ratio;
        // If backend already provides value → show it
        if (formSave?.type === 'engine_cond') {
            if (fhFcRatio === Infinity || isNaN(fhFcRatio) || fhFcRatio === 0 || fhFcRatio === "0" || fhFcRatio === null || fhFcRatio === undefined) {
                return "--";
            } else {
                return Number(fhFcRatio).toFixed(2);
            }
        } else {
            if (fhFcRatio === Infinity || isNaN(fhFcRatio) || fhFcRatio === 0 || fhFcRatio === "0" || fhFcRatio === null || fhFcRatio === undefined) {
                return "--";
            } else {
                if (storedValue !== undefined && storedValue !== null && storedValue !== "") {
                    return storedValue;
                }
            }
        }
        return Number(fhFcRatio).toFixed(2);
    };

    const calculateAchieveFHS = () => {
        const trendingAt = Number(data?.engine_condition_stands?.expected_fh_interval?.trending_at);
        const averageOf = Number(data?.engine_condition_stands?.expected_fh_interval?.average_of);

        if (trendingAt == null || averageOf == null || fh_fc_ratio == null || isNaN(fh_fc_ratio) ||
            isNaN(trendingAt) || isNaN(averageOf) ||
            averageOf === 0) {
            return '--';
        }
        const result = (trendingAt / averageOf) * Math.round(fh_fc_ratio * 100) / 100 * 1000;
        if (isNaN(result) || !isFinite(result)) {
            return '--';
        }
        if (result === 0) {
            return '--';
        }
        const rounded = Math.round(result * 100) / 100;
        if (rounded % 1 === 0) {
            return rounded?.toString() || '--';
        }
        return rounded?.toFixed(2) || '--';

    };

    const svNextCall = (modeTye, row, extra) => {
        if (modeTye === 'add') {
            setData(prev => (
                {
                    ...prev,
                    engine_condition_stands: {
                        ...prev?.engine_condition_stands,
                        next_sv_date: [
                            ...prev?.engine_condition_stands?.next_sv_date,
                            { sv_type: null, date: null, tsn: null, csn: null, llp_limiter: null, egtm: null, deltedId: Math.floor(Math.random() * 90) + 10 }]
                    }
                }

            ));

        } else if (row?.id) {
            setLoading(true)
            globalDeleteService(`/technical/t015/basic-inspection/${row?.id}/delete/?module=sv_date`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setData(prev => (
                            {
                                ...(prev),
                                engine_condition_stands: {
                                    ...prev.engine_condition_stands,
                                    next_sv_date:
                                        [...data?.engine_condition_stands.next_sv_date]?.filter(item => item?.id !== row?.id)
                                }
                            }

                        ));
                        setDeleteModal({ modal: false, data: null })
                        setLoading(false)
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Estimated next shop visit date',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    } else {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Estimated next shop visit date',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    }
                });
        } else {
            setData(prev => (
                {
                    ...(prev),
                    engine_condition_stands: {
                        ...prev.engine_condition_stands,
                        next_sv_date:
                            [...data?.engine_condition_stands.next_sv_date]?.filter(item => item?.deltedId !== extra?.deltedId)
                    }
                }

            ));
        }

    }

    function calculateNextHSVDueToFH(incomingData) {

        const technical = data?.technical_records || {};
        const engine = data?.engine_condition_stands || {};
        const fcInterval = engine?.expected_fc_interval || {};

        const asOfDate = technical?.as_of_date_llp;
        const tsn = Number(technical?.tsn) || 0;
        const csn = Number(technical?.csn) || 0;

        let achieve_fhs = calculateAchieveFHS();
        let interval_fhs = interval_fhsCal;
        let avg_fh = Number(engine?.avg_fh);
        let avg_fc = Number(engine?.avg_fc);
        let fhfc_ratio = getFhFcRatioValue(data, fh_fc_ratio);
        let engine_fcs = Number(fcInterval?.engine_fcs) || 0;
        let fh_due_date = asOfDate ? new Date(asOfDate) : null;

        if (asOfDate) {
            if (avg_fh && avg_fh > 0) {
                const a = achieve_fhs > 0 ? achieve_fhs / avg_fh : Infinity;
                const b = interval_fhs > 0 ? interval_fhs / avg_fh : Infinity;

                const minInterval = Math.min(a, b);

                if (minInterval !== Infinity) {
                    const d = new Date(asOfDate);
                    d.setDate(d.getDate() + Math.floor(minInterval));
                    fh_due_date = d;
                } else {
                    fh_due_date = new Date(asOfDate);
                }

            }
            if (!avg_fc) {
                fh_due_date = new Date(asOfDate);
            }
        }
        let total_tsn = null;

        if (tsn >= 0) {
            const vals = [];
            if (achieve_fhs > 0) vals.push(achieve_fhs);
            if (interval_fhs > 0) vals.push(interval_fhs);

            if (vals.length === 2) {
                total_tsn = tsn + Math.min(...vals);
            } else if (achieve_fhs > 0) {
                total_tsn = tsn + achieve_fhs;
            } else if (interval_fhs > 0) {
                total_tsn = tsn + interval_fhs;
            } else {
                total_tsn = tsn;
            }
            if (!avg_fc) {
                total_tsn = tsn;
            }
        }

        let total_csn = null;

        if (csn >= 0) {
            if (fhfc_ratio > 0) {
                const vals = [];
                if (achieve_fhs > 0) vals.push(achieve_fhs);
                if (interval_fhs > 0) vals.push(interval_fhs);

                const minFH = vals.length ? Math.min(...vals) : null;

                if (minFH) {
                    total_csn = csn + (minFH / fhfc_ratio);
                } else {
                    total_csn = csn;
                }

            } else {
                total_csn = csn;
            }
        }

        let llp_limiter = null;

        if (engine_fcs >= 0) {
            if (fhfc_ratio > 0) {
                const values = [];
                if (achieve_fhs > 0) values.push(achieve_fhs / fhfc_ratio);
                if (interval_fhs > 0) values.push(interval_fhs / fhfc_ratio);

                if (values.length) {
                    llp_limiter = Math.round(engine_fcs - Math.min(...values));
                } else {
                    llp_limiter = engine_fcs;
                }

            } else {
                llp_limiter = engine_fcs;

            }
        }

        const result = {
            date: fh_due_date ? fh_due_date.toISOString().split("T")[0] : null,
            tsn: total_tsn ? Math.round(total_tsn) : null,
            csn: total_csn ? Math.round(total_csn) : null,
            llp_limiter: llp_limiter !== null ? llp_limiter >= 0 ? Math.round(llp_limiter) : "Beyond Limit" : null,
            egtm: 0
        };

        if (incomingData === "fhhsv_date") return result.date;
        if (incomingData === "fhhsv_tsn") return result.tsn;
        if (incomingData === "fhhsv_csn") return result.csn;
        if (incomingData === "fhhsv_llplimiter") return result.llp_limiter;
        if (incomingData === "fhhsv_egtm") return result.egtm;

        return result;
    }

    function calculateNextHSVDueToFC(incomingData) {

        const technical = data?.technical_records || {};
        const engine = data?.engine_condition_stands || {};
        const fhInterval = engine?.expected_fh_interval || {};
        const fcInterval = engine?.expected_fc_interval || {};

        const asOfDate = technical?.as_of_date_llp;
        const tsn = Number(technical?.tsn) || 0;
        const csn = Number(technical?.csn) || 0;

        let avg_fc = Number(engine?.avg_fc);
        let fhfc_ratio = getFhFcRatioValue(data, fh_fc_ratio);

        let fcs_remaining = Number(fcInterval?.fcs_remaining);
        let removal_fcs = Number(fcInterval?.removal_fcs);

        let trending_at = Number(fhInterval?.trending_at) || 0;
        let average_of = Number(fhInterval?.average_of) || 0;


        let fc_due_date = null;

        if (asOfDate) {
            const dateObj = new Date(asOfDate);
            avg_fc = avg_fc && avg_fc > 0 ? avg_fc : null;
            fcs_remaining = fcs_remaining && fcs_remaining > 0 ? fcs_remaining : 0;
            removal_fcs = removal_fcs && removal_fcs > 0 ? removal_fcs : 0;
            if (avg_fc && avg_fc > 0) {
                const vals = [fcs_remaining, removal_fcs].filter(v => v);
                const min_fc_interval = vals.length ? Math.min(...vals) : null;
                if (min_fc_interval) {
                    const d = new Date(dateObj);
                    d.setDate(d.getDate() + Math.floor(min_fc_interval / avg_fc));
                    fc_due_date = d;
                } else {
                    fc_due_date = dateObj;
                }
            } else {
                fc_due_date = dateObj;
            }
        }
        let total_tsn = null;
        if (tsn >= 0) {
            if (fhfc_ratio && fhfc_ratio >= 0) {
                if (fcs_remaining && removal_fcs) {
                    const min_fc_interval = Math.min(fcs_remaining, removal_fcs);
                    total_tsn = tsn + (min_fc_interval * fhfc_ratio);
                } else if (fcs_remaining) {
                    total_tsn = tsn + (fcs_remaining * fhfc_ratio);
                } else if (removal_fcs) {
                    total_tsn = tsn + (removal_fcs * fhfc_ratio);
                } else {
                    total_tsn = tsn;

                }

            } else { total_tsn = tsn; }
            if (!avg_fc) {
                total_tsn = tsn;
            }
        }
        let total_csn = null;
        if (csn >= 0) {
            if (fcs_remaining && removal_fcs) {
                const min_fc_interval = Math.min(fcs_remaining, removal_fcs);
                total_csn = csn + min_fc_interval;
            } else if (fcs_remaining) {
                total_csn = csn + fcs_remaining;
            } else if (removal_fcs) {
                total_csn = csn + removal_fcs;
            } else {
                total_csn = csn;
            }
        }
        const minFC = Math.min(fcs_remaining > 0 ? fcs_remaining : Infinity, removal_fcs > 0 ? removal_fcs : Infinity);
        const round0 = (val) => Math.round(val);
        const egtm_value = minFC !== Infinity ? round0(Math.max(trending_at || 0, 0) - Math.max(average_of || 0, 0) * (minFC / 1000)) : null;
        // const egtm_value = Math.max(trending_at || 0, 0) - Math.max(average_of || 0, 0) * (Math.min(Math.max(removal_fcs || 0, 0), fcs_remaining) / 1000);
        const result = {
            date: fc_due_date ? fc_due_date.toISOString().split("T")[0] : null,
            tsn: total_tsn && total_tsn > 0 ? Math.round(total_tsn) : null,
            csn: total_csn && total_csn > 0 ? Math.round(total_csn) : null,
            llp_limiter: 0,
            egtm: egtm_value > 0 ? egtm_value : null
        };
        if (incomingData === "fchsv_date") return result.date;
        if (incomingData === "fchsv_tsn") return result.tsn;
        if (incomingData === "fchsv_csn") return result.csn;
        if (incomingData === "fchsv_llpLimiter") return result.llp_limiter;
        if (incomingData === "fchsv_egtm") return result.egtm ;
        return result;
    }

    return (
        <section className='form-t015'>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4> 3. Engine Condition Assessment :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'engine_cond' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'engine_cond', isdisabled: true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'engine_cond' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Grid container spacing={1}>
                    <Grid item>
                        <span>The engine was</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            options={['not installed', 'installed in position 1', 'installed in position 2']}
                            getOptionLabel={option => option}
                            id="installed_on_wing"
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '220px' }}
                            value={['not installed', 'installed in position 1', 'installed in position 2'].filter(item => item === data?.engine_condition_stands?.condition_assessment?.installed_on_wing)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'installed_on_wing', value, 'engine_condition_stands', '', '', 'condition_assessment')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                        />
                        <span className='span-style'>on-wing at the time of the inspection.The engine was installed on Aircraft Reg</span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            value={data?.engine_condition_stands?.aircraft_reg || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                            inputProps={{ maxLength: 50 }}
                            onChange={(e) => onFieldChange(e, 'aircraft_reg', e.target.value ? e.target.value : null, 'engine_condition_stands')}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '250px' }}
                        />
                        <span className='span-style'>/ having MSN</span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            value={data?.engine_condition_stands?.having_msn || ''}
                            InputLabelProps={{ shrink: true }}
                            placeholder="Enter"
                            size='small'
                            inputProps={{ maxLength: 50 }}
                            onChange={(e) => onFieldChange(e, 'having_msn', e.target.value ? e.target.value : null, 'engine_condition_stands')}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '250px' }}
                        />
                        <span className='span-style'>and is in</span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            options={['serviceable', 'unserviceable']}
                            style={{ display: 'inline-grid', width: '150px', marginLeft: '5px', }}
                            getOptionLabel={option => option}
                            id="condition_assessment"
                            value={['serviceable', 'unserviceable'].filter(item => item === data?.engine_condition_stands?.condition_assessment?.condition_assessment)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'condition_assessment', value, 'engine_condition_stands', '', '', 'condition_assessment')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' />}
                        />
                        <span className='span-style'>condition.</span>
                    </Grid>
                </Grid>
                <div style={{ marginTop: '10px' }}>
                    <CkEditorText
                        placeholder='If not installed, provide preservation type & storage location, otherwise Enter.. "N/A" '
                        disabled={!onCheckFormPermission(currentFormDetail) || isLoading}
                        htmlData={data?.engine_condition_stands?.condition_assessment?.install_note || ''}
                        // onBlurData={() => callthisapi('', data?.engine_condition_stands?.condition_assessment?.install_note)}
                        onChangeData={(value) => setData({
                            ...data,
                            engine_condition_stands: {
                                ...data?.engine_condition_stands,
                                condition_assessment: {
                                    ...data?.engine_condition_stands?.condition_assessment,
                                    install_note: value
                                }
                            }
                        })}
                    />
                </div>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell><h6>Average Daily Flight Hours</h6></TableCell>
                            <TableCell >
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    variant='outlined'
                                    margin='normal'
                                    id='avg_fh'
                                    value={data?.engine_condition_stands?.avg_fh || ''}
                                    placeholder="Enter.."
                                    fullWidth
                                    onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'avg_fh', e.target.value ? e.target.value : null, 'engine_condition_stands') : e.preventDefault() }}
                                    inputProps={{ maxLength: 10 }}
                                />
                            </TableCell>
                            <TableCell><h6>Average Daily Flight Cycles</h6> </TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    variant='outlined'
                                    margin='normal'
                                    id='avg_fc'
                                    value={data?.engine_condition_stands?.avg_fc || ''}
                                    placeholder="Enter.."
                                    fullWidth
                                    // inputProps={{ maxLength: 5 }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const numericValue = value?.replace(/[^0-9.]/g, '');
                                        const dotCount = (numericValue.match(/\./g) || []).length;
                                        let isValid = false;
                                        if (dotCount > 1) {
                                            isValid = false;
                                        } else if (numericValue === '') {
                                            isValid = true;
                                        } else {
                                            const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                            const intLenOk = integerPart?.length <= 5;
                                            const decLenOk = fractionalPart?.length <= 2;
                                            const isNum = /^\d{1,5}(\.\d{0,2})?$/.test(numericValue);
                                            isValid = intLenOk && decLenOk && isNum;
                                        }
                                        if (isValid || value === '') {
                                            onFieldChange(e, 'avg_fc', value ? numericValue : null, 'engine_condition_stands');
                                        }
                                    }}
                                />
                            </TableCell>
                            <TableCell><h6>FH: FC Ratio</h6> </TableCell>
                            <TableCell>
                                <TextField
                                    variant='outlined'
                                    margin='normal'
                                    id='fh_fc_ratio'
                                    value={getFhFcRatioValue(data, fh_fc_ratio)}
                                    // value={data?.engine_condition_stands?.fh_fc_ratio ? data?.engine_condition_stands?.fh_fc_ratio : fh_fc_ratio === Infinity || isNaN(fh_fc_ratio) || fh_fc_ratio === 0 || fh_fc_ratio === "0" ? '--' : fh_fc_ratio.toFixed(2) || '--'}
                                    placeholder="Enter.."
                                    fullWidth
                                    disabled
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>

                            <TableCell><h6>{smbcInstance ? 'TLPR' : 'TSL HSV'}</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    variant='outlined'
                                    margin='normal'
                                    id='tsl_hsv'
                                    value={data?.engine_condition_stands?.tsl_hsv || ''}
                                    onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'tsl_hsv', e.target.value ? e.target.value : null, 'engine_condition_stands') : e.preventDefault() }}
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                />
                            </TableCell>
                            <TableCell><h6>{smbcInstance ? 'CLPR' : 'CSL HSV'}</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    variant='outlined'
                                    margin='normal'
                                    id='csl_hsv'
                                    value={data?.engine_condition_stands?.csl_hsv || ''}
                                    onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'csl_hsv', e.target.value ? e.target.value : null, 'engine_condition_stands') : e.preventDefault() }}
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 10 }}
                                />
                            </TableCell>
                            <TableCell><h6>Average Derate %</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    variant='outlined'
                                    margin='normal'
                                    id='avg_derate_percentage'
                                    value={data?.engine_condition_stands?.avg_derate_percentage || ''}
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: !regexConstants.numberWithDot.test(data?.engine_condition_stands?.avg_derate_percentage) && 3 }}
                                    onChange={(e) => { // source chatgpt
                                        const value = e.target.value;
                                        const numericValue = value?.replace(/[^\d.]/g, '');
                                        const dotCount = (numericValue.match(/\./g) || [])?.length;
                                        let isValid = false;
                                        if (dotCount > 1) {
                                            isValid = false;
                                        } else if (numericValue === '') {
                                            isValid = true;
                                        } else if (dotCount === 1) {
                                            const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                            const integerNum = integerPart === '' ? 0 : parseInt(integerPart, 10);
                                            const num = parseFloat(numericValue);
                                            isValid = (
                                                integerPart?.length <= 3 &&
                                                integerNum <= 100 &&
                                                fractionalPart?.length <= 2 &&
                                                num <= 100 &&
                                                regexConstants.numberWithDot.test(numericValue)
                                            );
                                        } else {
                                            const integerNum = parseInt(numericValue, 10);
                                            isValid = (
                                                numericValue.length <= 3 &&
                                                integerNum <= 100 &&
                                                regexConstants.numberWithDot.test(numericValue)
                                            );
                                        }
                                        if (isValid || value === '') {
                                            onFieldChange(e, 'avg_derate_percentage', value ? numericValue : null, 'engine_condition_stands');
                                        }
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table className='mui-table-format-t015' style={{ marginTop: '10px' }} >
                    <TableBody >
                        <TableRow>
                            <TableCell><h6>Last SV Date</h6></TableCell>
                            <TableCell width='200'>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        margin="normal"
                                        id="last_sv_date"
                                        format={displayDateFormatShort}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={data?.engine_condition_stands?.last_sv_date ? data?.engine_condition_stands?.last_sv_date : null}
                                        onChange={(date) => onFieldChange('', 'last_sv_date', date ? moment(date).format(backendDateFormat) : null, 'engine_condition_stands', '', 'date')}
                                        inputVariant='outlined'
                                    />
                                </MuiPickersUtilsProvider>
                            </TableCell>
                            <TableCell><h6>Last SV Reason</h6></TableCell>
                            <TableCell width='700'>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                    margin='normal'
                                    id='last_sv_reason'
                                    value={data?.engine_condition_stands?.last_sv_reason ? data?.engine_condition_stands?.last_sv_reason : null}
                                    onChange={(e) => onFieldChange(e, 'last_sv_reason', e.target.value, 'engine_condition_stands')}
                                    placeholder="Enter.."
                                    fullWidth
                                    variant='outlined'
                                    inputProps={{ maxLength: 250 }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <h5 style={{ margin: "10px 0px" }}>Expected Flight Hour Interval : </h5>
                <Grid container spacing={1}>
                    <Grid item>
                        <TextField
                            variant='outlined'
                            id='operator_id'
                            placeholder="Enter.."
                            disabled
                            value={data?.operator_id || ''}
                            style={{ verticalAlign: 'middle', width: '140px' }}
                        />
                        <span className='span-style'> HSV interval for</span>
                        <TextField
                            variant='outlined'
                            id='current_tr'
                            placeholder="Enter.."
                            disabled
                            value={data?.current_tr || ''}
                            style={{ verticalAlign: 'middle', width: '120px' }}
                        />
                        <span className='span-style'>thrust is </span>
                        <Tooltip placement='top' title={smbcInstance ? 'It should be always greater than TLPR' : 'It should be always greater than TSL HSV'}>
                            <TextField
                                disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                variant='outlined'
                                id='thrust_is'
                                value={data?.engine_condition_stands?.expected_fh_interval?.thrust_is || ''}
                                onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'thrust_is', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fh_interval') : e.preventDefault() }}
                                placeholder="Enter..."
                                size="small"
                                style={{ verticalAlign: 'middle', width: '120px' }}
                                inputProps={{ maxLength: 10 }}
                            />
                        </Tooltip>
                        <span className='span-style'>FHs.The remaining heavy shop visit interval is</span>
                        <TextField
                            variant='outlined'
                            id='interval_fhs'
                            value={formSave?.type === 'engine_cond' ? interval_fhsCal > 0 ? Math.round(interval_fhsCal) : '--' : data?.engine_condition_stands?.expected_fh_interval?.interval_fhs >= 0 ? data?.engine_condition_stands?.expected_fh_interval?.interval_fhs : interval_fhsCal > 0 ? Math.round(interval_fhsCal) : '--'}
                            placeholder="Enter..."
                            size="small"
                            disabled
                            style={{ verticalAlign: 'middle', width: '120px' }}
                            className='span-style'
                        />
                        <span>FHs.</span>
                    </Grid>
                    <Grid item>
                        <span>EGT Margin at date of inspection is trending at</span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='trending_at'
                            className='span-style'
                            value={data?.engine_condition_stands?.expected_fh_interval?.trending_at >= 0 ? data?.engine_condition_stands?.expected_fh_interval?.trending_at : ''}
                            onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'trending_at', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fh_interval') : e.preventDefault() }}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle', width: '120px' }}
                            inputProps={{ maxLength: 10 }}
                        />
                        <span>°C. Based on an average of </span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='average_of'
                            value={data?.engine_condition_stands?.expected_fh_interval?.average_of >= 0 ? data?.engine_condition_stands?.expected_fh_interval?.average_of : ''}
                            onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'average_of', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fh_interval') : e.preventDefault() }}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle', width: '120px' }}
                            inputProps={{ maxLength: 10 }}
                        />
                        <span className='span-style'> °C of margin lost per 1,000 cycles flown.It is expected that the Engine</span>
                        <span> may potentially achieve </span>
                        <TextField
                            variant='outlined'
                            id='achieve_fhs'
                            disabled
                            placeholder="Enter..."
                            value={formSave?.type === 'engine_cond' ? calculateAchieveFHS() : data?.engine_condition_stands?.expected_fh_interval?.achieve_fhs ?? calculateAchieveFHS()}
                            size="small"
                            style={{ verticalAlign: 'middle', width: '120px' }}
                            inputProps={{ maxLength: 10 }}
                        />
                        <span> FHs on-wing until EGT margin limitation.</span>
                    </Grid>
                </Grid>
                <h5 style={{ margin: "10px 0px" }}>Expected Flight Cycle Interval :</h5>
                <Grid container spacing={1}>
                    <Grid item>
                        <span style={{ marginRight: '5px' }}>Engine has got</span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='engine_fcs'
                            value={data?.engine_condition_stands?.expected_fc_interval?.engine_fcs || ''}
                            // onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'engine_fcs', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fc_interval') : e.preventDefault() }}
                            placeholder="Enter..."
                            size="small"
                            style={{ width: '100px' }}
                            onChange={(e) => {
                                const value = e.target.value;
                                const numericValue = value?.replace(/[^0-9.]/g, '');
                                const dotCount = (numericValue.match(/\./g) || []).length;
                                let isValid = false;
                                if (dotCount > 1) {
                                    isValid = false;
                                } else if (numericValue === '') {
                                    isValid = true;
                                } else {
                                    const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                    const intLenOk = integerPart?.length <= 5;
                                    const decLenOk = fractionalPart?.length <= 2;
                                    const isNum = /^\d{1,5}(\.\d{0,2})?$/.test(numericValue);
                                    isValid = intLenOk && decLenOk && isNum;
                                }
                                if (isValid || value === '') {
                                    onFieldChange(e, 'engine_fcs', value ? numericValue : null, 'engine_condition_stands', '', '', 'expected_fc_interval');
                                }
                            }}
                        />
                        <span className='span-style'>FCs remaining at </span>
                        <TextField
                            variant='outlined'
                            id='remaining_at'
                            disabled
                            value={data?.current_tr || ''}
                            placeholder="Enter..."
                            size="small"
                            style={{ width: '120px' }}
                            inputProps={{ maxLength: 5 }}
                        />
                        <span className='span-style'>thrust. The limiting hot section LLP is the</span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='section_llp'
                            value={data?.engine_condition_stands?.expected_fc_interval?.section_llp || ''}
                            onChange={(e) => onFieldChange(e, 'section_llp', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fc_interval')}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle' }}
                            inputProps={{ maxLength: 100 }}
                        />
                        <span className='span-style'>which has got </span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='fcs_remaining'
                            value={data?.engine_condition_stands?.expected_fc_interval?.fcs_remaining || ''}
                            // onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'fcs_remaining', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fc_interval') : e.preventDefault() }}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle', width: '100px' }}
                            onChange={(e) => {
                                const value = e.target.value;
                                const numericValue = value?.replace(/[^0-9.]/g, '');
                                const dotCount = (numericValue.match(/\./g) || []).length;
                                let isValid = false;
                                if (dotCount > 1) {
                                    isValid = false;
                                } else if (numericValue === '') {
                                    isValid = true;
                                } else {
                                    const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                    const intLenOk = integerPart?.length <= 5;
                                    const decLenOk = fractionalPart?.length <= 2;
                                    const isNum = /^\d{1,5}(\.\d{0,2})?$/.test(numericValue);
                                    isValid = intLenOk && decLenOk && isNum;
                                }
                                if (isValid || value === '') {
                                    onFieldChange(e, 'fcs_remaining', value ? numericValue : null, 'engine_condition_stands', '', '', 'expected_fc_interval');
                                }
                            }}
                        />
                        <span className='span-style'>FCs remaining.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <span>The other LLP with the lowest life that may result in a HSV is the </span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='hsv'
                            value={data?.engine_condition_stands?.expected_fc_interval?.hsv || ''}
                            onChange={(e) => onFieldChange(e, 'hsv', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fc_interval')}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle' }}
                            inputProps={{ maxLength: 100 }}
                        />
                        <span className='span-style'>which will require removal in  </span>
                        <TextField
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            variant='outlined'
                            id='removal_fcs'
                            value={data?.engine_condition_stands?.expected_fc_interval?.removal_fcs || ''}
                            // onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'removal_fcs', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_fc_interval') : e.preventDefault() }}
                            placeholder="Enter..."
                            size="small"
                            style={{ verticalAlign: 'middle', width: '100px' }}
                            onChange={(e) => {
                                const value = e.target.value;
                                const numericValue = value?.replace(/[^0-9.]/g, '');
                                const dotCount = (numericValue.match(/\./g) || []).length;
                                let isValid = false;
                                if (dotCount > 1) {
                                    isValid = false;
                                } else if (numericValue === '') {
                                    isValid = true;
                                } else {
                                    const [integerPart, fractionalPart = ''] = numericValue?.split('.');
                                    const intLenOk = integerPart?.length <= 5;
                                    const decLenOk = fractionalPart?.length <= 2;
                                    const isNum = /^\d{1,5}(\.\d{0,2})?$/.test(numericValue);
                                    isValid = intLenOk && decLenOk && isNum;
                                }
                                if (isValid || value === '') {
                                    onFieldChange(e, 'removal_fcs', value ? numericValue : null, 'engine_condition_stands', '', '', 'expected_fc_interval');
                                }
                            }}
                        />
                        <span className='span-style'>FCs.</span>
                    </Grid>
                </Grid>
                <h5 style={{ margin: '10px 0px 10px' }}>Expected Interval (other) :</h5>
                <Grid item xs={12}>
                    <span>Engine </span>
                    <Autocomplete
                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                        options={['is', 'is not']}
                        getOptionLabel={option => option}
                        style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                        id="ad_engine"
                        value={['is', 'is not'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.ad_engine)[0] || null}
                        onChange={(e, value) => onFieldChange(e, 'ad_engine', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                        renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                    />
                    <span className='span-style'>limited by an Airworthiness Directive which will result in a premature removal.</span>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Table className='mui-table-format-t015' style={{ marginTop: '10px' }} >
                            <TableBody >
                                <TableRow>
                                    <TableCell width='850px'>
                                        <CkEditorText
                                            placeholder='If yes, please provide AD Ref and Details. If no, please enter.. "N/A".'
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            htmlData={data?.engine_condition_stands?.expected_interval_other?.ad_note || ''}
                                            // onBlurData={() => callthisapi('', data?.engine_condition_stands?.expected_interval_other?.ad_note)}
                                            onFocusData={(e, value) => setInitialValue(e, value)}
                                            onChangeData={(value) => setData({
                                                ...data,
                                                engine_condition_stands: {
                                                    ...data?.engine_condition_stands,
                                                    expected_interval_other: {
                                                        ...data?.engine_condition_stands?.expected_interval_other,
                                                        ad_note: value
                                                    }
                                                }
                                            })}
                                        />
                                    </TableCell>
                                    <TableCell width='100'>
                                        <Autocomplete
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            options={['FH Limit', 'FC Limit', 'Calender', 'N/A']}
                                            getOptionLabel={option => option}
                                            style={{ display: 'inline-grid', width: '140px' }}
                                            id="ad_type"
                                            value={['FH Limit', 'FC Limit', 'Calender', 'N/A'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.ad_type)[0] || null}
                                            onChange={(e, value) => onFieldChange(e, 'ad_type', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                        />
                                    </TableCell>
                                    <TableCell width='150'>
                                        <TextField
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            variant='outlined'
                                            margin='normal'
                                            id='ad_value'
                                            placeholder='Enter'
                                            inputProps={{ maxLength: 10 }}
                                            InputLabelProps={{ shrink: true }}


                                            value={data?.engine_condition_stands?.expected_interval_other?.ad_value || ''}
                                            onChange={(e) => onFieldChange(e, 'ad_value', e.target.value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <span>Engine </span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            options={['is', 'is not']}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            id="bsi_engine"
                            value={['is', 'is not'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.bsi_engine)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'bsi_engine', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>limited by reduced interval inspections as a result of Borescope findings.    </span>
                    </Grid>
                    <Grid item xs={12}>
                        <Table className='mui-table-format-t015' style={{ marginTop: '10px' }} >
                            <TableBody >
                                <TableRow>
                                    <TableCell width='850px'>
                                        <CkEditorText
                                            placeholder='If yes, please provide BSI task and findings. If no, please enter.. "N/A".'
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            htmlData={data?.engine_condition_stands?.expected_interval_other?.bsi_note || ''}
                                            // onBlurData={() => callthisapi('', data?.engine_condition_stands?.expected_interval_other?.bsi_note)}
                                            onFocusData={(e, value) => setInitialValue(e, value)}
                                            onChangeData={(value) => setData({
                                                ...data,
                                                engine_condition_stands: {
                                                    ...data?.engine_condition_stands,
                                                    expected_interval_other: {
                                                        ...data?.engine_condition_stands?.expected_interval_other,
                                                        bsi_note: value
                                                    }
                                                }
                                            })}
                                        />
                                    </TableCell>
                                    <TableCell width='100px'>
                                        <Autocomplete
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            options={['FH Limit', 'FC Limit', 'Calender', 'N/A']}
                                            getOptionLabel={option => option}
                                            className='engine-stand-select'
                                            style={{ display: 'inline-grid', width: '140px' }}
                                            id="bsi_type"
                                            value={['FH Limit', 'FC Limit', 'Calender', 'N/A'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.bsi_type)[0] || null}
                                            onChange={(e, value) => onFieldChange(e, 'bsi_type', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                        />
                                    </TableCell>
                                    <TableCell width='150px'>
                                        <TextField
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            variant='outlined'
                                            margin='normal'
                                            id='bsi_value'
                                            placeholder='Enter'
                                            inputProps={{ maxLength: 10 }}
                                            InputLabelProps={{ shrink: true }}


                                            value={data?.engine_condition_stands?.expected_interval_other?.bsi_value || ''}
                                            onChange={(e) => onFieldChange(e, 'bsi_value', e.target.value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ marginTop: '10px' }} >
                        <span>Engine </span>
                        <Autocomplete
                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                            options={['is', 'is not']}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            id="other_engine"
                            value={['is', 'is not'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.other_engine)[0] || null}
                            onChange={(e, value) => onFieldChange(e, 'other_engine', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>limited by another reason which may cause premature removal.    </span>
                    </Grid>
                    <Grid item xs={12}>
                        <Table className='mui-table-format-t015' style={{ marginTop: '10px' }} >
                            <TableBody >
                                <TableRow>
                                    <TableCell width='850px'>
                                        <CkEditorText
                                            placeholder='If yes, please provide information. If no, please enter.. "N/A".'
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            htmlData={data?.engine_condition_stands?.expected_interval_other?.other_note || ''}
                                            // onBlurData={() => callthisapi('', data?.engine_condition_stands?.expected_interval_other?.other_note)}
                                            onFocusData={(e, value) => setInitialValue(e, value)}
                                            onChangeData={(value) => setData({
                                                ...data,
                                                engine_condition_stands: {
                                                    ...data?.engine_condition_stands,
                                                    expected_interval_other: {
                                                        ...data?.engine_condition_stands?.expected_interval_other,
                                                        other_note: value
                                                    }
                                                }
                                            })}
                                        />
                                    </TableCell>
                                    <TableCell width='100px'>
                                        <Autocomplete
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            options={['FH Limit', 'FC Limit', 'Calender', 'N/A']}
                                            getOptionLabel={option => option}
                                            className='engine-stand-select'
                                            style={{ display: 'inline-grid', width: '140px' }}
                                            id="other_type"
                                            value={['FH Limit', 'FC Limit', 'Calender', 'N/A'].filter(item => item === data?.engine_condition_stands?.expected_interval_other?.other_type)[0] || null}
                                            onChange={(e, value) => onFieldChange(e, 'other_type', value, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                                        />
                                    </TableCell>
                                    <TableCell width='150px'>
                                        <TextField
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            variant='outlined'
                                            margin='normal'
                                            id='other_value'
                                            placeholder='Enter'
                                            inputProps={{ maxLength: 10 }}
                                            InputLabelProps={{ shrink: true }}
                                            value={data?.engine_condition_stands?.expected_interval_other?.other_value || ''}
                                            onChange={(e) => onFieldChange(e, 'other_value', e.target.value ? e.target.value : null, 'engine_condition_stands', '', '', 'expected_interval_other')}
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h5 style={{ margin: '10px 0px 5px' }}>Estimated Next Shop Visit Date : </h5>
                    </li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Button disabled={formSave?.type !== 'engine_cond' || !onCheckFormPermission(currentFormDetail)} onClick={() => svNextCall("add")} color="primary" variant="contained" size="small" style={{ margin: '5px' }} >+ ADD</Button>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell> </TableCell>
                            <TableCell><h6>Date</h6> </TableCell>
                            <TableCell><h6>TSN</h6> </TableCell>
                            <TableCell><h6>CSN</h6> </TableCell>
                            <TableCell><h6>LLP Limit</h6> </TableCell>
                            <TableCell><h6>EGTM</h6> </TableCell>
                            <TableCell><h6>Action</h6> </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            [data?.engine_condition_stands?.next_hsv_due_to_fh]?.map((item, index) => (
                                <TableRow>
                                    <TableCell style={{ textAlignLast: 'center' }}> Next HSV due to FH </TableCell>
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="date"
                                                format={displayDateFormatShort}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFH("fhhsv_date") : item?.date || null}
                                                disabled
                                                inputVariant='outlined'
                                            />
                                        </MuiPickersUtilsProvider>
                                    </TableCell>
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <TextField value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFH("fhhsv_tsn") : item?.tsn ?? ''} disabled variant='outlined' fullWidth placeholder="Enter.." id='tsn' />
                                    </TableCell>
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <TextField value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFH("fhhsv_csn") : item?.csn ?? ''} disabled variant='outlined' fullWidth placeholder="Enter.." id='csn' />
                                    </TableCell>
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <TextField
                                            value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFH("fhhsv_llplimiter") : item?.llp_limiter >= 0 || item?.llp_limiter ? item?.llp_limiter ?? '' : ''}
                                            disabled
                                            variant='outlined'
                                            fullWidth
                                            placeholder="Enter.."
                                            id='llp_limiter'
                                        />
                                    </TableCell>
                                    <TableCell style={{ textAlignLast: 'center' }}>
                                        <TextField
                                            value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFH("fhhsv_egtm") : item?.egtm ?? ''}
                                            variant='outlined'
                                            fullWidth
                                            placeholder="Enter.."
                                            id='egtm'
                                            disabled
                                        />
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {[data?.engine_condition_stands?.next_hsv_due_to_fc]?.map((item, index) => (
                            <TableRow>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    Next HSV due to FC
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date"
                                            format={displayDateFormatShort}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFC("fchsv_date") : item?.date || null}
                                            disabled
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFC("fchsv_tsn") : item?.tsn ?? ''} disabled variant='outlined' fullWidth placeholder="Enter.." id='tsn' />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFC("fchsv_csn") : item?.csn ?? ''} disabled variant='outlined' fullWidth placeholder="Enter.." id='csn' />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        value={(formSave?.type === 'engine_cond' || formSave?.type === 'tech_records') ? calculateNextHSVDueToFC("fchsv_llpLimiter") : item?.llp_limiter ?? ''}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Enter.."
                                        id='llp_limiter'
                                        disabled
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        value={
                                            (formSave?.type === 'engine_cond' || formSave?.type === 'tech_records')
                                                ? calculateNextHSVDueToFC("fchsv_egtm") ?? ''
                                                : item?.egtm > 0 ? item?.egtm : ''
                                        }
                                        disabled
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Enter.."
                                        id="egtm"
                                    />
                                </TableCell>
                                <TableCell>

                                </TableCell>
                            </TableRow>
                        ))
                        }
                        {data?.engine_condition_stands?.next_sv_date?.map((item, index) => (
                            <TableRow>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Next HSV due to (Other)"
                                        id='date'
                                        value={item?.sv_type}
                                        onChange={(e) => onFieldChange(e, 'sv_type', e.target.value ? e.target.value : null, 'engine_condition_stands', index, '', 'next_sv_date')}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                            margin="normal"
                                            id="date"
                                            format={displayDateFormatShort}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={item?.date || null}
                                            onChange={(date) => onFieldChange('', 'date', date ? moment(date).format(backendDateFormat) : null, 'engine_condition_stands', index, 'date', 'next_sv_date')}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Enter.."
                                        id='tsn'
                                        value={item?.tsn || ''}
                                        onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'tsn', e.target.value ? e.target.value : null, 'engine_condition_stands', index, '', 'next_sv_date') : e.preventDefault() }}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Enter.."
                                        id='csn'
                                        value={item?.csn || ''}
                                        onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onFieldChange(e, 'csn', e.target.value ? e.target.value : null, 'engine_condition_stands', index, '', 'next_sv_date') : e.preventDefault() }}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Enter.."
                                        id='llp_limiter'
                                        value={item?.llp_limiter}
                                        onChange={(e) => onFieldChange(e, 'llp_limiter', e.target.value ? e.target.value : null, 'engine_condition_stands', index, '', 'next_sv_date')}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_cond'}
                                        variant='outlined'
                                        fullWidth
                                        placeholder="Enter.."
                                        id='egtm'
                                        value={item?.egtm}
                                        onChange={(e, value) => onFieldChange(e, 'egtm', e.target.value ? e.target.value : null, 'engine_condition_stands', index, '', 'next_sv_date')}
                                    />
                                </TableCell>
                                <TableCell align='center'>
                                     <Tooltip title='Delete' arrow>
                                    <IconButton disabled={formSave?.type !== 'engine_cond' || !onCheckFormPermission(currentFormDetail)} color='secondary' >
                                        <DeleteOutlinedIcon onClick={() => { item?.id ? setDeleteModal({ modal: true, data: item }) : svNextCall('', '', item) }} />
                                    </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))
                        }
                    </TableBody>
                </Table>
            </Paper>
            {deleteModal?.modal ?
                <DeletePopUp
                    modal={deleteModal.modal}
                    toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
                    title="Estimated Next Shop Visit Date"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => svNextCall('', deleteModal?.data)}
                /> : null
            }
        </section>
    );
}

export default EngineCondition